import { useQuery } from "@tanstack/react-query";
import { GateView } from "../types";
import { programmeDashboardApi } from "../api/programmeDashboard";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

const mapRagLabelToColor = (
  ragLabel: string
): "red" | "green" | "yellow" => {
  if (ragLabel === "At Risk") return "red";
  if (ragLabel === "Watch") return "yellow";
  return "green";
};

export const usePhaseCounts = ({ portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["phase-counts", portfolio_id , quickFilters],
    queryFn: () => {
      const params = {
        portfolio_id: portfolio_id,
        workstream_id: extractFilterValues(quickFilters.workstream) || null,
        site_id: extractFilterValues(quickFilters.site) || null,
        programme_id: extractFilterValues(quickFilters.programme) || null,
        region_id: extractFilterValues(quickFilters.region) || null,
        work_type_group_id: extractFilterValues(quickFilters['worktype-group']) || null,
        project_year: extractFilterValues(quickFilters.projectYear) || null,
      };
      return programmeDashboardApi.fetchPhaseCounts(params)
    },
  });

  const gates: GateView[] = data?.data
    ? data.data.map((phase) => ({
      gate: phase.name,
      count: phase.project_count,
      color: mapRagLabelToColor(phase.ragLabel),
    }))
    : [];

  return {
    gates,
    isLoading,
    isError,
    error:
      error instanceof Error
        ? error.message
        : "Failed to fetch phase counts",
  };
};

